import { h } from '@stencil/core';
import cn from 'classnames';
export class PesSoftwareModalHeaderCell {
  constructor() {
    this.label = undefined;
    this.index = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: cn('pes-software-modal-header-cell', this.index === 0 && 'pes-software-modal-header-cell--first') }, this.label));
  }
  static get is() { return "pes-software-modal-header-cell"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-software-modal-header-cell.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-software-modal-header-cell.css"]
    };
  }
  static get properties() {
    return {
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Text in the cell"
        },
        "attribute": "label",
        "reflect": false
      },
      "index": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Index of the cell. Used in styling: first cell has special behavior."
        },
        "attribute": "index",
        "reflect": false
      }
    };
  }
  static get elementRef() { return "el"; }
}
